<template v-if="items.length">
  <div>
    <v-tabs
      :class="[tabsOnly ? 'd-block' : 'd-none d-md-block']"
      :value="cmpItems.findIndex(item => item[itemValue] === value)"
      active-class="tab-active"
      class="rounded"
      grow
      hide-slider
      :optional="optional"
      @change="handleTabsInput"
    >
      <v-tab
        v-for="(item, index) in cmpItems"
        :key="item[itemValue]"
        :class="[getDividerClass(item[itemValue], index)]"
        :disabled="item.disabled"
        class="ul-tabs--tab"
        data-cy="UlTabsTab"
        ><span v-html="item[itemText]"
      /></v-tab>
    </v-tabs>
    <UlSelect
      :class="[tabsOnly ? 'd-none' : 'd-flex d-md-none']"
      :item-text="itemText"
      :item-value="itemValue"
      :menu-props="{ offsetOverflow: false }"
      :options="cmpItems"
      :value="value"
      append-icon="$dropSmall"
      hide-details
      @input="handleInput"
    />
  </div>
</template>

<script>
export default {
  name: 'UlTabs',
  props: {
    items: {
      type: Array,
      required: true
    },
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    tabsOnly: {
      type: Boolean,
      default: false
    },
    optional: {
      type: Boolean,
      default: true
    },
    value: {
      type: [String, Number],
      validator(value) {
        return typeof value === 'string' || typeof value === 'number' || value === null;
      }
    }
  },
  computed: {
    cmpItems() {
      if (this.items.every(item => typeof item === 'string' || typeof item === 'number')) {
        return this.items.map((item, index) => ({
          [this.itemValue]: index,
          [this.itemText]: item
        }));
      }

      return this.items;
    }
  },
  methods: {
    handleInput(value) {
      this.$emit('input', value);
    },
    handleTabsInput(index) {
      const item = this.cmpItems[index];
      if (item) {
        this.$emit('input', item[this.itemValue]);
      }
    },
    getDividerClass(value, index) {
      const valueIndex = this.cmpItems.findIndex(item => item[this.itemValue] === value);
      const selectedIndex = this.cmpItems.findIndex(item => item[this.itemValue] === this.value);
      const absoluteDiff = Math.abs(valueIndex - selectedIndex);

      if (absoluteDiff >= 2) {
        return index === 0 ? 'has-right-divider' : 'has-left-divider';
      }

      return '';
    }
  }
};
</script>

<style scoped lang="scss">
.has-right-divider {
  &:after {
    opacity: 1 !important;
  }
}

.has-left-divider {
  &:before {
    opacity: 1 !important;
  }
}

.ul-tabs--tab {
  margin: 3px;

  &.v-tab--disabled {
    pointer-events: auto;
    cursor: not-allowed;

    &:hover,
    &:focus,
    &:active {
      color: rgba(0, 0, 0, 0.54) !important;
    }

    &:hover::before,
    &:focus::before {
      opacity: 0 !important;
    }
  }
}
</style>
